import {FaFacebook, FaGithub, FaInstagram, FaTwitter, FaWhatsapp} from 'react-icons/fa'
const Footer = () => {
    return(
        <div className="w-full bg-black text-white">
            <div className="max-w-[1250px] mx-auto grid mt-[35px] p-6 md:grid-cols-3">
                <div className='md:col-span-3'>
                    <h1 className="text-2xl text-green-500 font-bold">REACT.</h1>
                    <p className="mt-4">
                     Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio ipsa quam reiciendis vitae amet consectetur fugit nobis repellendus, dolorem neque pariatur, numquam eius voluptate suscipit asperiores non commodi fuga? Temporibus?
                    </p>
                    <div className='flex mt-5 w-full justify-between text-green-500 md:col-span-3'>
                        <FaFacebook size={20} className="animate-pulse"/>
                        <FaTwitter size={20}/>
                        <FaInstagram size={20} className="animate-pulse"/>
                        <FaGithub size={20}/>
                        <FaWhatsapp size={20} className="animate-pulse"/>
                    </div>
                </div>
                {/* <div className='flex justify-between mt-10 px-4'>
                    <div>
                        <ul>
                            <li>Solutions</li>
                            <li>Analytics</li>
                            <li>Marketing</li>
                            <li>Commerce</li>
                            <li>Insights</li>
                        </ul>
                    </div>
                    <div>
                        <ul className='flex flex-col text-right'>
                            <li>Support</li>
                            <li>Pricing</li>
                            <li>Documentation</li>
                            <li>Guides</li>
                            <li>API Status</li>
                        </ul>
                    </div>
                </div>
                <div className='flex justify-between mt-10 px-4'>
                    <div>
                        <ul>
                            <li>Company</li>
                            <li>About</li>
                            <li>Blog</li>
                            <li>Jobs</li>
                            <li>Press</li>
                            
                        </ul>
                    </div>
                    <div>
                        <ul className='flex flex-col text-right'>
                            <li>Legal</li>
                            <li>Claim</li>
                            <li>Privacy</li>
                            <li>Partners</li>
                            <li>Terms</li>
                        </ul>
                    </div>
                </div> */}
            </div>
        </div>
    )
}
export default Footer;